import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

const countries = [
  {
    Code: "AL",
    Name: "Albania",
  },
  {
    Code: "AD",
    Name: "Andorra",
  },
  {
    Code: "AG",
    Name: "Antigua",
  },
  {
    Code: "AR",
    Name: "Argentina",
  },
  {
    Code: "AW",
    Name: "Aruba",
  },
  {
    Code: "AU",
    Name: "Australia",
  },
  {
    Code: "AT",
    Name: "Austria",
  },
  {
    Code: "AZ",
    Name: "Azerbaijan",
  },
  {
    Code: "BS",
    Name: "Bahamas",
  },
  {
    Code: "BH",
    Name: "Bahrain",
  },
  {
    Code: "BB",
    Name: "Barbados",
  },
  {
    Code: "BY",
    Name: "Belarus",
  },
  {
    Code: "BE",
    Name: "Belgium",
  },
  {
    Code: "BO",
    Name: "Bolivia",
  },
  {
    Code: "BA",
    Name: "Bosnia Herzegovina",
  },
  {
    Code: "BW",
    Name: "Botswana",
  },
  {
    Code: "BR",
    Name: "Brazil",
  },
  {
    Code: "BN",
    Name: "Brunei Darussalam",
  },
  {
    Code: "BG",
    Name: "Bulgaria",
  },
  {
    Code: "KH",
    Name: "Cambodia",
  },
  {
    Code: "CM",
    Name: "Cameroon",
  },
  {
    Code: "CA",
    Name: "Canada",
  },
  {
    Code: "CL",
    Name: "Chile",
  },
  {
    Code: "CN",
    Name: "China",
  },
  {
    Code: "CO",
    Name: "Colombia",
  },
  {
    Code: "CK",
    Name: "Cook Islands",
  },
  {
    Code: "CR",
    Name: "Costa Rica",
  },
  {
    Code: "HR",
    Name: "Croatia",
  },
  {
    Code: "CY",
    Name: "Cyprus",
  },
  {
    Code: "CZ",
    Name: "Czech Republic",
  },
  {
    Code: "DK",
    Name: "Denmark",
  },
  {
    Code: "DO",
    Name: "Dominican Republic",
  },
  {
    Code: "EC",
    Name: "Ecuador",
  },
  {
    Code: "EG",
    Name: "Egypt",
  },
  {
    Code: "EE",
    Name: "Estonia",
  },
  {
    Code: "ET",
    Name: "Ethiopia",
  },
  {
    Code: "FJ",
    Name: "Fiji",
  },
  {
    Code: "FI",
    Name: "Finland",
  },
  {
    Code: "FR",
    Name: "France",
  },
  {
    Code: "PF",
    Name: "French Polynesia",
  },
  {
    Code: "DE",
    Name: "Germany",
  },
  {
    Code: "GI",
    Name: "Gibraltar",
  },
  {
    Code: "GR",
    Name: "Greece",
  },
  {
    Code: "GD",
    Name: "Grenada",
  },
  {
    Code: "GP",
    Name: "Guadeloupe",
  },
  {
    Code: "GU",
    Name: "Guam",
  },
  {
    Code: "GT",
    Name: "Guatemala",
  },
  {
    Code: "HK",
    Name: "Hong Kong",
  },
  {
    Code: "HU",
    Name: "Hungary",
  },
  {
    Code: "IS",
    Name: "Iceland",
  },
  {
    Code: "IN",
    Name: "India",
  },
  {
    Code: "ID",
    Name: "Indonesia",
  },
  {
    Code: "IE",
    Name: "Ireland(Republic of)",
  },
  {
    Code: "IL",
    Name: "Israel",
  },
  {
    Code: "IT",
    Name: "Italy",
  },
  {
    Code: "JM",
    Name: "Jamaica",
  },
  {
    Code: "JP",
    Name: "Japan",
  },
  {
    Code: "JO",
    Name: "Jordan",
  },
  {
    Code: "KE",
    Name: "Kenya",
  },
  {
    Code: "KW",
    Name: "Kuwait",
  },
  {
    Code: "LA",
    Name: "Laos",
  },
  {
    Code: "LV",
    Name: "Latvia",
  },
  {
    Code: "LB",
    Name: "Lebanon",
  },
  {
    Code: "LY",
    Name: "Libya",
  },
  {
    Code: "LI",
    Name: "Liechtenstein",
  },
  {
    Code: "LT",
    Name: "Lithuania",
  },
  {
    Code: "LU",
    Name: "Luxembourg",
  },
  {
    Code: "MO",
    Name: "Macau",
  },
  {
    Code: "MY",
    Name: "Malaysia",
  },
  {
    Code: "MT",
    Name: "Malta",
  },
  {
    Code: "MU",
    Name: "Mauritius",
  },
  {
    Code: "MX",
    Name: "Mexico",
  },
  {
    Code: "MC",
    Name: "Monaco",
  },
  {
    Code: "MN",
    Name: "Mongolia",
  },
  {
    Code: "MA",
    Name: "Morocco",
  },
  {
    Code: "MM",
    Name: "Myanmar",
  },
  {
    Code: "NA",
    Name: "Namibia",
  },
  {
    Code: "NP",
    Name: "Nepal",
  },
  {
    Code: "NL",
    Name: "Netherlands",
  },
  {
    Code: "AN",
    Name: "Netherlands Antilles",
  },
  {
    Code: "NC",
    Name: "New Caledonia",
  },
  {
    Code: "NZ",
    Name: "New Zealand",
  },
  {
    Code: "NG",
    Name: "Nigeria",
  },
  {
    Code: "MP",
    Name: "Northern Mariana Isl",
  },
  {
    Code: "NO",
    Name: "Norway",
  },
  {
    Code: "OM",
    Name: "Oman",
  },
  {
    Code: "PW",
    Name: "Palau",
  },
  {
    Code: "PA",
    Name: "Panama",
  },
  {
    Code: "PY",
    Name: "Paraguay",
  },
  {
    Code: "PE",
    Name: "Peru",
  },
  {
    Code: "PH",
    Name: "Philippines",
  },
  {
    Code: "PL",
    Name: "Poland",
  },
  {
    Code: "PT",
    Name: "Portugal",
  },
  {
    Code: "PR",
    Name: "Puerto Rico",
  },
  {
    Code: "QA",
    Name: "Qatar",
  },
  {
    Code: "RO",
    Name: "Romania",
  },
  {
    Code: "RU",
    Name: "Russia",
  },
  {
    Code: "RU",
    Name: "Russian Federation",
  },
  {
    Code: "WS",
    Name: "Samoa",
  },
  {
    Code: "SM",
    Name: "San Marino",
  },
  {
    Code: "SA",
    Name: "Saudi Arabia",
  },
  {
    Code: "SN",
    Name: "Senegal",
  },
  {
    Code: "RS",
    Name: "Serbia",
  },
  {
    Code: "SC",
    Name: "Seychelles",
  },
  {
    Code: "SG",
    Name: "Singapore",
  },
  {
    Code: "SK",
    Name: "Slovakia",
  },
  {
    Code: "SI",
    Name: "Slovenia",
  },
  {
    Code: "ZA",
    Name: "South Africa",
  },
  {
    Code: "KR",
    Name: "South Korea",
  },
  {
    Code: "ES",
    Name: "Spain",
  },
  {
    Code: "LK",
    Name: "Sri Lanka",
  },
  {
    Code: "KN",
    Name: "St Kitts & Nevis",
  },
  {
    Code: "LC",
    Name: "St Lucia",
  },
  {
    Code: "VC",
    Name: "St Vincent & Grenadi",
  },
  {
    Code: "SZ",
    Name: "Swaziland",
  },
  {
    Code: "SE",
    Name: "Sweden",
  },
  {
    Code: "CH",
    Name: "Switzerland",
  },
  {
    Code: "TW",
    Name: "Taiwan",
  },
  {
    Code: "TZ",
    Name: "Tanzania",
  },
  {
    Code: "TH",
    Name: "Thailand",
  },
  {
    Code: "TO",
    Name: "Tonga",
  },
  {
    Code: "TT",
    Name: "Trinidad & Tobago",
  },
  {
    Code: "TN",
    Name: "Tunisia",
  },
  {
    Code: "TR",
    Name: "Turkey",
  },
  {
    Code: "TC",
    Name: "Turks & Caicos Islan",
  },
  {
    Code: "UA",
    Name: "Ukraine",
  },
  {
    Code: "AE",
    Name: "United Arab Emirates",
  },
  {
    Code: "GB",
    Name: "United Kingdom",
  },
  {
    Code: "US",
    Name: "United States",
  },
  {
    Code: "UY",
    Name: "Uruguay",
  },
  {
    Code: "VU",
    Name: "Vanuatu",
  },
  {
    Code: "VE",
    Name: "Venezuela",
  },
  {
    Code: "VN",
    Name: "Vietnam",
  },
  {
    Code: "VI",
    Name: "Virgin Islands (USA)",
  },
  {
    Code: "YE",
    Name: "Yemen Republic",
  },
  {
    Code: "ZM",
    Name: "Zambia",
  },
  {
    Code: "ZW",
    Name: "Zimbabwe",
  },
];

const HotelDestination = ({ setCountryValue, countryValue, country }) => {
  const [value, setValue] = useState("");

  const handleAutocompleteChange = (event, value) => {
    // Use the retrieved value as needed

    const filterCode = countries.filter((data) => value === data.Name);
    setCountryValue(filterCode[0]?.Code);
    setValue(filterCode[0]?.Name);
    // 
  };

  useEffect(() => {
    if (country !== "") {
      const filterCode = countries.filter((data) => country === data.Code);
      setValue(filterCode[0]?.Name);
    }
  }, [country]);

  return (
    <>
      <Box
        className={`searchMenu-loc lg:px-0 js-form-dd`}
        sx={{
          "& label.Mui-focused": {
            color: "black",
          },
          "& .MuiInputBase-input": {
            // height: "16px",
          },
          "& .MuiAutocomplete-clearIndicator": {
            display: "none", // Hides the clear (close) button
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
          "& .MuiInput-underline:after": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
              borderRadius: "8px",
            },
            "&:hover fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
            },
            "&.Mui-focused fieldset": {
              border: "1px solid rgba(0, 0, 0, 0.5)",
            },
          },
        }}
      >
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={countries.map((data) => data.Name)}
          value={value}
          onChange={handleAutocompleteChange}
          renderInput={(params) => (
            <TextField {...params} placeholder="Country" />
          )}
        />
      </Box>
    </>
  );
};

export default HotelDestination;
